"use client"

import * as LucideIcons from "lucide-react"
import { MoreHorizontal, Trash2, Zap, Circle } from "lucide-react"
import { Link, useLocation } from "react-router-dom"

import { useAccesosRapidos } from "@/shared/context/AccesosRapidosContext"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/shared/components/ui/sidebar'

// Helper para obtener el componente de icono por nombre
function getIconComponent(iconName: string): React.ComponentType<{ className?: string }> {
  const icons = LucideIcons as unknown as Record<string, React.ComponentType<{ className?: string }>>
  return icons[iconName] || Circle
}

export function NavProjects() {
  const { isMobile } = useSidebar()
  const location = useLocation()
  const { items, isLoading, removeAccesoRapido } = useAccesosRapidos()

  // No mostrar la seccion si esta cargando
  if (isLoading) {
    return null
  }

  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel className="flex items-center gap-1">
        <Zap className="size-3 text-gray-500" />
        Accesos Rapidos
      </SidebarGroupLabel>
      <SidebarMenu>
        {items.length === 0 ? (
          <SidebarMenuItem>
            <SidebarMenuButton className="text-sidebar-foreground/50 italic cursor-default hover:bg-transparent" disabled>
              <span className="text-xs">Usa el icono de rayo para agregar</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        ) : (
          items.map((item) => {
            const IconComponent = getIconComponent(item.icon)
            const isActive = location.pathname === item.url || location.pathname.startsWith(item.url + "/")

            return (
              <SidebarMenuItem key={item.id}>
                <SidebarMenuButton asChild isActive={isActive}>
                  <Link to={item.url}>
                    <IconComponent className="size-4" />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <SidebarMenuAction showOnHover>
                      <MoreHorizontal />
                      <span className="sr-only">Mas opciones</span>
                    </SidebarMenuAction>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent
                    className="w-48 rounded-lg"
                    side={isMobile ? "bottom" : "right"}
                    align={isMobile ? "end" : "start"}
                  >
                    <DropdownMenuItem
                      onClick={() => removeAccesoRapido(item.id)}
                      className="text-red-600 focus:text-red-600"
                    >
                      <Trash2 className="text-red-600" />
                      <span>Eliminar</span>
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </SidebarMenuItem>
            )
          })
        )}
      </SidebarMenu>
    </SidebarGroup>
  )
}
